"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypographySpanSelectable = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
const markTextOnSingleClick = (e) => {
    const selection = window.getSelection();
    if (selection.type !== "Range") {
        const range = document.createRange();
        range.selectNodeContents(e.target);
        selection.removeAllRanges();
        selection.addRange(range);
    }
};
/**
 * This component wraps the [Typography](https://material-ui.com/api/typography/) component and selects the text of its children on single click.
 * If you mark the text with your mouse, or double click on parts of the text to marka selection it will still work
 * Propagation of onClick and onDoubleClick is by default stopped to prevent issues with other actions (like opening a dialog) obstructing the marking behavior.
 * This can be overridden by defining your own onClick or onDoubleClick.
 * The underlying component is a "span" so it wraps only the text.
 */
const TypographySpanSelectable = (props, ref) => {
    const { onClick, ...rest } = props;
    return (react_1.default.createElement(Typography_1.default, { component: "span", onDoubleClick: (e) => e.stopPropagation(), ...rest, ref: ref, onClick: (e) => {
            if (!e.defaultPrevented) {
                markTextOnSingleClick(e);
            }
            if (onClick) {
                onClick(e);
            }
            else {
                e.stopPropagation();
            }
        } }));
};
exports.TypographySpanSelectable = TypographySpanSelectable;
const TypographySpanSelectableWithRef = react_1.default.forwardRef(exports.TypographySpanSelectable);
exports.default = TypographySpanSelectableWithRef;
